import * as React from "react";

import { IconCheck, IconFrown } from "@common/components/Atoms/Icons";

interface CheckboxProps {
    description?: string;
    isChecked?: boolean;
    inputRef?: any;
    isValid?: boolean;
    label?: string;
    name: string;
    onBlur?: () => void;
    onChange?: (name: string, value: any) => void;
    onFocus?: () => void;
    onValidate?: (e) => void;
    readOnly?: boolean;
    required?: boolean;
    validationMessageOverride?: string;
    validationMessages?: string[];
    validationTrigger?: boolean;
    value?: any;
}

export class Checkbox extends React.Component<CheckboxProps> {
    static defaultProps = {
        isChecked: false,
        required: false,
        readOnly: false,
        validationTrigger: false,
        name: ""
    };

    constructor(props: CheckboxProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    onChange(event) {
        if (this.props.onChange) {
            this.props.onChange(this.props.name, event.target.checked);
        }
    }

    onBlur() {
        if (this.props.onBlur) this.props.onBlur();
    }

    onFocus() {
        if (this.props.onFocus) this.props.onFocus();
    }

    render() {
        return (
            <div className="c-block">
                <div
                    className={
                        "c-control c-control--checkbox " +
                        (!this.props.isValid ? "has-error" : "")
                    }
                >
                    {this.props.label && (
                        <div className="c-control__label">
                            <label htmlFor={"checkbox_" + this.props.name}>
                                {this.props.label}
                            </label>
                            {this.props.description && (
                                <p>{this.props.description}</p>
                            )}
                        </div>
                    )}
                    <div className="c-control__wrapper">
                        <label>
                            <input
                                type="checkbox"
                                className={
                                    "c-inputs__checkbox " +
                                    (!this.props.isValid ? "has-error" : "")
                                }
                                id={"checkbox_" + this.props.name}
                                name={this.props.name}
                                checked={this.props.value}
                                required={this.props.required}
                                readOnly={this.props.readOnly}
                                onChange={this.onChange}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                ref={this.props.inputRef}
                            />

                            <span>{this.props.value && <IconCheck />}</span>
                        </label>
                    </div>
                    {!this.props.isValid && (
                        <div className="c-control__message">
                            <IconFrown />
                            {this.props.validationMessages &&
                                this.props.validationMessages.map(
                                    (msg, ind) => (
                                        <span key={ind}>{msg + " "}</span>
                                    )
                                )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
